module.exports = __webpack_public_path__ + "media/mimic.aac5229f.mp3";